import { FootPrintPadHoleType, PcbNodeTypes, isCopperLayer, matchLayerIdentifier, } from "@buildwithflux/models";
export function getLayerIdentifiersForNode(node) {
    switch (node.type) {
        // Trace: only return the layer it's on
        case PcbNodeTypes.routeSegment: {
            return [node.bakedRules.layer];
        }
        // Pads:
        // - Single layer for SMD pads
        // - All layers/connected layers for plated TH pads
        // - No connected layers for non-plated TH pads
        case PcbNodeTypes.pad: {
            const isSingleLayer = !node.bakedRules.hole ||
                node.bakedRules.hole.holeType === FootPrintPadHoleType.SurfaceMountDevice ||
                node.bakedRules.hole.holeType === FootPrintPadHoleType.testPinOrCardEdgeConnector;
            const isPlatedTH = node.bakedRules.hole && node.bakedRules.hole.holeType === FootPrintPadHoleType.platedThroughHole;
            // 1. No connected layers for non-plated TH pads
            if (!isPlatedTH && !isSingleLayer) {
                return [];
            }
            // 2. Single layer for SMD pads
            if (isSingleLayer) {
                return [node.bakedRules.layer];
            }
            // 3. All connected layers as fallback or if "All" is specified
            if (!node.bakedRules.connectedLayers || node.bakedRules.connectedLayers.includes("All")) {
                return ["All"];
            }
            // 4. Connected layers rule
            return node.bakedRules.connectedLayers;
        }
        // Vias: use connected layers rule
        case PcbNodeTypes.via: {
            if (!node.bakedRules.connectedLayers || node.bakedRules.connectedLayers.includes("All")) {
                return ["All"];
            }
            return node.bakedRules.connectedLayers;
        }
        // Net nodes: just return the baked connected layers directly
        case PcbNodeTypes.net:
        case PcbNodeTypes.polygon: {
            return node.bakedRules.connectedLayers;
        }
        default: {
            return [];
        }
    }
}
/**
 * Returns the copper layers connected to a
 * - via segment (if under a smart via),
 * - regular via node,
 * - pad,
 * - route segment,
 * - net node (used for fill layering).
 *
 * Note: It is the responsibility of the caller to ensure that the stackup layers are ordered.
 */
export function getConnectedCopperLayers(node, stackup) {
    const copperLayers = stackup.filter(isCopperLayer);
    if (!copperLayers.length) {
        return [];
    }
    // string array of layer identifiers, or ["All"]
    const connectedLayerIdentifiers = getLayerIdentifiersForNode(node);
    return copperLayers.filter((layer) => {
        if (!connectedLayerIdentifiers || connectedLayerIdentifiers.includes("All")) {
            return true;
        }
        return connectedLayerIdentifiers.some((layerId) => matchLayerIdentifier(layer, layerId));
    });
}
//# sourceMappingURL=getConnectedCopperLayers.js.map